
import { Component, Vue } from 'vue-property-decorator'
import { popUpRoute } from '@/services/utils/popupRoute'
import { IProduct } from '@/modules/inventory/product/types/productTypes'
import { Field } from '@/services/utils/baseForm'
import eventBus from '@/eventBus'
import { sellerEndpoints } from '@/modules/seller'
import { CeleryApiType } from '@/modules/celery-task/types/celeryTaskTypes'
import { productEndpoints } from '@/modules/inventory/product'
import { stockEndpoints } from '@/modules/inventory/stock'
import { ModelApi } from '@/services/api/modelApi'
import { weightEstimationEndpoints } from '@/modules/inventory/weight-estimation'
import { apiRequestEndpoint } from '@/modules/preference/api-integration'

@Component({
  name: 'ImportFile',
  components: {
    BaseForm: () =>
      import(
        /* webpackChunkName : "BaseForm"*/ '@/stories/base-form/BaseForm.vue'
      ),
    DialogBaseSkeleton: () =>
      import(
        /* webpackChunkName : "DialogBaseSkeleton"*/ '@/stories/dialog-base-skeleton/DialogBaseSkeleton.vue'
      )
  }
})
export default class ImportFile extends Vue {
  celeryApiType = this.$route.params.celeryApiType || ''
  isDownloading = false

  /**
   * function will be passed to child components
   * @params product which modules type the fetched product will be passed to it in the child component. (base form)
   */
  fields = () => [
    Field.dropdown<IProduct>(
      'merchant',
      'merchantId',
      () => sellerEndpoints.list(),
      'fullName',
      'id'
    )
      .required()
      .setHidden(
        this.celeryApiType !== CeleryApiType.PRODUCT &&
          this.celeryApiType !== CeleryApiType.STOCK
      )
      .setCol('col-12'),
    Field.file<IProduct>('file', 'uploadProductAttachment')
      .setProps({
        accept: '.csv'
      })
      .setRules('ext:csv')
      .required()
      .setCol('col-12')
  ]

  /** submit the data to the desired endpoint. */
  async handleSubmit(values: IProduct) {
    //Note: handle it in more dynamic way :(
    if (this.celeryApiType === CeleryApiType.PRODUCT)
      await productEndpoints
        .import({ file: values.file, merchantId: values.merchantId })
        .then(() => this.closePopUp())

    if (this.celeryApiType === CeleryApiType.STOCK)
      await stockEndpoints
        .import({ file: values.file, merchantId: values.merchantId })
        .then(() => this.closePopUp())
    if (this.celeryApiType === CeleryApiType.WEIGHT_ESTIMATION)
      await weightEstimationEndpoints
        .import({ file: values?.file })
        .then(() => this.closePopUp())

    if (this.celeryApiType === CeleryApiType.REST_API)
      await apiRequestEndpoint
        .importApiRequest({ file: values?.file })
        .then(() => this.closePopUp())

    eventBus.refreshData()
  }

  /** Download template for the current celery API type */
  async downloadTemplate() {
    try {
      this.isDownloading = true

      // Check if celeryApiType is one of the valid enum values
      const validCeleryTypes = Object.values(CeleryApiType) as string[]
      if (this.celeryApiType && validCeleryTypes.includes(this.celeryApiType)) {
        // Use ModelApi directly instead of specific endpoints
        const modelApi = new ModelApi('', '')
        await modelApi.downloadTemplate(this.celeryApiType)
      } else {
        throw new Error(
          `Invalid or missing celery API type: ${
            this.celeryApiType
          }. Valid types are: ${validCeleryTypes.join(', ')}`
        )
      }
    } finally {
      this.isDownloading = false
    }
  }

  closePopUp() {
    popUpRoute.removeModalPath()
  }
}
